import React from "react";
import { Card, Col, Row, Button } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";

// Lesson component for individual lesson list items

/**
 * Populates a card with the lesson information
 * @returns
 */
const Lesson = ({ title, length, description, topics, page }) => {
  return (
    <div style={{ backgroundColor: "transparent" }}>
      <Card>
        <Card.Header className="bg-success text-white">
          <Row>
            <Col>
              <h3>{title}</h3>
            </Col>
            <Col className="text-end">
              <h4>Rating: ⭐</h4>
            </Col>
            <Col className="text-end">
              <h4>Expected Length: {length}</h4>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={{ span: 5, offset: 0 }}>
              <h5>Description</h5>
              <p>{description}</p>
            </Col>
            <Col md={{ span: 4, offset: 3 }}>
              <h5>Topics</h5>
              <ul>
                {topics.map((topic, index) => (
                  <li key={index}>{topic}</li>
                ))}
              </ul>
              <Nav>
                <Nav.Link href={page} variant="dark">
                  <Button variant="info">Begin Lesson</Button>
                </Nav.Link>
              </Nav>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Lesson;
